/**
 * Bus passenger custom validations
 * Extracted from passengerConfig for readability and reuse
 */

/**
 * Returns custom validation rules for bus passenger selection
 * @param {Object} BUS_PASSENGER_TYPES - Slugs for passenger types
 * @returns {Array} List of validation rule objects
 */
export const createBusPassengerCustomValidations = (BUS_PASSENGER_TYPES) => [
  /*
  TODO: FO-1798 yetişkin zorunluluğu kaldırıldı
  {
    rule: (values) => {
      const adults = values[BUS_PASSENGER_TYPES.ADULT] || 0;
      return adults >= 1;
    },
    messageKey: "bus.passengerValidationMinAdult",
    message: "En az bir yetişkin yolcu seçilmesi gerekmektedir",
    path: BUS_PASSENGER_TYPES.ADULT,
  },
  */
  /*
  {
    rule: (values) => {
      const children = values[BUS_PASSENGER_TYPES.CHILD] || 0;
      if (children > 0) {
        const adults =
          (values[BUS_PASSENGER_TYPES.ADULT] || 0) +
          (values[BUS_PASSENGER_TYPES.YOUNG] || 0);
        return adults >= 1;
      }
      return true;
    },
    messageKey: "bus.passengerValidationChildNeedsAdult",
    message: "Çocuk yolcular için en az bir yetişkin veya genç gereklidir",
    path: BUS_PASSENGER_TYPES.CHILD,
  },
  */
];


